import React from 'react';
import { SiteHeader } from '../components/landing/SiteHeader';
import { Hero } from '../components/landing/Hero';
import { StatsBand } from '../components/landing/StatsBand';
import { BeforeAfter } from '../components/landing/BeforeAfter';
import { Scenes } from '../components/landing/Scenes';
import { HowItWorks } from '../components/landing/HowItWorks';
import { PackContents } from '../components/landing/PackContents';
import { Volumes } from '../components/landing/Volumes';
import { InstantDelivery } from '../components/landing/InstantDelivery';
import { Bonuses } from '../components/landing/Bonuses';
import { Offer } from '../components/landing/Offer';
import { Guarantee } from '../components/landing/Guarantee';
import { Testimonials } from '../components/landing/Testimonials';
import { About } from '../components/landing/About';
import { Faq } from '../components/landing/Faq';
import { FinalCta } from '../components/landing/FinalCta';
import { SiteFooter } from '../components/landing/SiteFooter';
export function Landing() {
  return <div className="min-h-screen w-full bg-cream font-sans text-ink" data-id="element-268" data-mp="2bboy9wr7zzy">
      <SiteHeader data-id="element-269" data-mp="3tfa3dfl2a27w" />
      <main data-id="element-270" data-mp="3tes03yzzenqh">
        <Hero data-id="element-271" data-mp="3tf0fpynho75d" />
        <StatsBand data-id="element-272" data-mp="3tio5qntq6bfc" />
        <BeforeAfter data-id="element-273" data-mp="3pegeaivvuhdf" />
        <Scenes data-id="element-274" data-mp="3pfrj8m12dv64" />
        <HowItWorks data-id="element-275" data-mp="3pf9qw0hiw13h" />
        <PackContents data-id="element-276" data-mp="3pgu9qsuh5vli" />
        <Volumes data-id="element-277" data-mp="3kfn4b0ft18i0" />
        <InstantDelivery data-id="element-278" data-mp="3kg6nekh6y2xm" />
        <Bonuses data-id="element-279" data-mp="3kgyepj3r9ei3" />
        <Offer data-id="element-280" data-mp="3khhmw83lsoix" />
        <Guarantee data-id="element-281" data-mp="3khzug0vpup65" />
        <Testimonials data-id="element-282" data-mp="l09x4bowdydq" />
        <About data-id="element-283" data-mp="kzgmv0qqcqqu" />
        <Faq data-id="element-284" data-mp="kz8d3hpwm1jv" />
        <FinalCta data-id="element-285" data-mp="kzqdmqjln1xl" />
      </main>
      <SiteFooter data-id="element-286" data-mp="gywu09d6w9ai" />
    </div>;
}